<div class="link-button {{ class }}"
     (click)="onClick.emit(true)"
     [ngClass]="{'link-button--small-right-margin':smallRightMargin}"
>
  <svg-icon [src]="iconUrl" *ngIf="iconUrl && iconUrl.length" [svgStyle]="{width: '16px', height: '16px'}"></svg-icon>
  {{ name }}
</div>
